<template>
  <div class="pack-body">
    <a-form-model ref="packForm" :model="packForm" :labelCol="{ span: 2 }" :wrapperCol="{ span: 18 }" :rules="rules">
      <a-form-model-item label="课程包名称" prop="name">
        <a-input v-model="packForm.name" placeholder="请输入课程包名称" :maxLength="15" style="width: 280px">
          <span slot="suffix">{{ packForm.name ? packForm.name.length : 0 }}/15</span>
        </a-input>
      </a-form-model-item>
      <a-form-model-item label="可用人次" prop="maxCount" :rules="[{ required: !packForm.isLimitCount, message: '请输入可用人次' }]">
        <div class="form-person">
          <a-input-number
            :disabled="packForm.isLimitCount"
            :min="packForm.usedCount || 1"
            :precision="0"
            :max="9999"
            v-model="packForm.maxCount"
            :style="packForm.error ? { borderColor: 'red' } : {}"
            placeholder="请输入可用人次"
            style="width: 140px"
          />
          <a-checkbox class="ml20" v-model="packForm.isLimitCount" @change="onChangeLimitPerson"> 不限制 </a-checkbox>
        </div>
      </a-form-model-item>
      <a-form-model-item
        v-if="courseType == 2 && !this.edit"
        label="课时数"
        prop="childCourseCount"
        :key="formKey"
        :rules="[
          { required: true, message: '请输入课时数' },
          { validator: validatorCourseCount, trigger: 'change' },
        ]"
      >
        <div class="form-hour">
          <a-tabs v-if="packMinList.length && !isCustomChildCount" type="card" v-model="activeHour" @change="changePackCountHour">
            <a-tab-pane v-for="item in packMinList" :key="item.value" :tab="item.label"> 已选{{ item.number }}节课 </a-tab-pane>
          </a-tabs>
          <template v-if="isCustomChildCount">
            <a-input-number v-model="packForm.childCourseCount" style="width: 140px" placeholder="请输入课时数" :min="0" :precision="0" :max="9999" />
            <!-- <a-checkbox class="ml20" @change="onChangeAllCourseCount"> 不限制 </a-checkbox> -->
          </template>
          <a-button v-if="packMinList.length" @click="changeCustom" type="link"> {{ isCustomChildCount ? '取消自定义' : '自定义' }} </a-button>
        </div>
      </a-form-model-item>
      <!-- <a-form-model-item v-if="courseType == 2" label="报告生成频率">
        <a-input-number v-model="packForm.reportFrequency" style="width: 140px" :min="1" :precision="0" :max="9999" placeholder="请输入整数" />
        <a-button type="primary" @click="useTableAll" style="margin-left: 16px">批量设置</a-button>
      </a-form-model-item> -->
    </a-form-model>
    <div class="pack-list">
      <div class="pack-title mt12">
        <h3>课程包内课程列表</h3>
        <a-button class="ml20" type="primary" @click="addCourse">新增课程资源</a-button>
      </div>
      <div class="pack-table">
        <a-form-model ref="tableForm" :model="gradeTableRelevant">
          <a-table :columns="columns" :pagination="false" row-key="id" :loading="gradeTableRelevant.tableLoading" :data-source="gradeTableRelevant.tableDataSource">
            <div slot="courseName" slot-scope="text">
              {{ text.courseName }}
            </div>
            <div class="action" slot="error" slot-scope="text">
              <span class="c-red">{{ errors[text.error] }}</span>
            </div>
            <div class="action" slot="action" slot-scope="text">
              <a-button :disabled="text.hasConfig" type="link" class="c-red" @click="removeCourse(text)">移除</a-button>
            </div>
            <div class="reportFrequency" slot="reportFrequency" slot-scope="text">
              <a-input-number v-model="text.reportFrequency" :disabled="edit && text._edit" style="width: 140px" :min="1" :precision="0" :max="9999" placeholder="请输入整数" />
            </div>
            <div class="report" slot="report" slot-scope="text, _, index">
              <a-form-model-item
                v-if="text.reportList && text.reportList.length"
                :prop="`tableDataSource[${index}].selectReportIds`"
                :rules="[{ required: true, type: 'array', message: '请选择报告' }]"
              >
                <a-select v-model="text.selectReportIds" :getPopupContainer="getPopupContainer" mode="multiple" :maxTagTextLength="6" :maxTagCount="1" placeholder="请选择报告" style="width: 260px" >
                  <a-select-option v-for="report in text.reportList" :value="report.id" :key="report.id">
                    {{ report.reportName }} {{ report.reportFrequency ? `- ${report.reportFrequency}` : '' }}
                  </a-select-option>
                </a-select>
              </a-form-model-item>
              <span v-else>--</span>
            </div>
          </a-table>
        </a-form-model>
      </div>
    </div>
    <a-modal v-model="selectCourse.visible" width="1200px" class="add-resource" :confirm-loading="selectCourse.loading" :centered="true" :destroyOnClose="true" title="选择课程" @ok="selectCourseOk">
      <addCourseResource ref="addCourseResourceTable" :type="textTit" :excludes="excludeIds" :minCourseChildCount="record.childCourseCount" />
    </a-modal>
  </div>
</template>
<script>
import { tableRelevant } from '@/pages/projectImpl/js/utils'
import addCourseResource from '@/pages/projectImpl/orgManage/components/AddCourseResource.vue'

const packHourList = [
  {
    label: '学期课',
    value: '4',
    number: 24,
  },
  {
    label: '学年课',
    value: '5',
    number: 48,
  },
  {
    label: '季度课',
    value: '1',
    number: 60,
  },
  {
    label: '半年课',
    value: '2',
    number: 120,
  },
  {
    label: '年度课',
    value: '3',
    number: 240,
  },
]

const rules = {
  name: [{ required: true, message: '请输入课程包名称' }],
  // configUserCount: [{ required: true, message: '请输入可用人次' }],
}

const errors = {
  1: '相同课时数课程已存在',
}
export default {
  name: 'PackResource',
  components: { addCourseResource },
  props: {
    courseList: {
      type: Array,
      default: () => [],
    },
    courseType: {
      type: [String, Number],
      default: 0,
    },
    textTit: {
      type: String,
      default: '',
    },
    edit: {
      type: Boolean,
      default: false,
    },
    record: {
      type: Object,
      default: () => ({}),
    },
  },
  watch: {
    courseList: {
      handler(val) {
        if (this.gradeTableRelevant.tableDataSource != val) {
          this.gradeTableRelevant.tableDataSource = JSON.parse(JSON.stringify(this.courseList))
          if (this.edit) {
            this.gradeTableRelevant.tableDataSource = this.gradeTableRelevant.tableDataSource.map((v) => ((v._edit = true), v))
          }
          // if (this.courseType != 2) {
          //   this.getReportTemplateByCourseId(this.courseList.map((v) => v._courseId))
          // }
          this.getReportTemplateByCourseId(this.courseList.map((v) => v._courseId))
        }
      },
      immediate: true,
    },
  },
  data() {
    return {
      formKey: +new Date(),
      errors: Object.freeze(errors),
      selectCourse: {
        visible: false,
        loading: false,
      },
      customChildCount: false,
      packHourList: Object.freeze(packHourList),
      rules: Object.freeze(rules),
      options: {},
      activeHour: 1,
      isLimitCount: false,
      gradeTableRelevant: tableRelevant.call(this),
      packForm: {
        isLimitCount: false,
        name: undefined,
        maxCount: undefined,
        childCourseCount: undefined,
        reportFrequency: undefined,
      },
      columns: [
        {
          title: '课程名称',
          scopedSlots: { customRender: 'courseName' },
        },
        {
          title: '学段',
          dataIndex: 'period',
        },
        {
          title: '课时数',
          dataIndex: 'courseChildCount',
        },
        {
          title: '配置报告',
          scopedSlots: { customRender: 'report' },
          width: 350,
        },
        {
          title: '操作',
          scopedSlots: { customRender: 'action' },
        },
        {
          title: '',
          scopedSlots: { customRender: 'error' },
          width: 180,
        },
      ],
    }
  },
  computed: {
    excludeIds() {
      return this.gradeTableRelevant.tableDataSource.map((v) => v._courseId)
    },
    isCustomChildCount() {
      return this.customChildCount || this.packMinList.length == 0
    },
    minChildCount() {
      if (!this.gradeTableRelevant.tableDataSource[0]) {
        return 0
      }
      return this.gradeTableRelevant.tableDataSource.reduce((minChildCount, item) => {
        if (item.courseChildCount < minChildCount) {
          return item.courseChildCount
        }
        return minChildCount
      }, this.gradeTableRelevant.tableDataSource[0].courseChildCount)
    },
    packMinList() {
      if (this.gradeTableRelevant.tableDataSource[0]) {
        return this.packHourList.filter((item) => item.number <= this.minChildCount)
      }
      return []
    },
  },
  created() {
    // if (this.courseType != 2) {
    //   this.columns.splice(3, 0, {
    //     title: '配置报告',
    //     scopedSlots: { customRender: 'report' },
    //     width: 350,
    //   })
    // } else {
    //   this.columns.splice(3, 0, {
    //     title: '报告生成频率',
    //     scopedSlots: { customRender: 'reportFrequency' },
    //     width: 160,
    //   })
    // }
  },

  methods: {
    useTableAll() {
      this.gradeTableRelevant.tableDataSource.forEach((item) => {
        console.log(item)

        if (!item._edit) {
          this.$set(item, 'reportFrequency', this.packForm.reportFrequency)
        }
      })
    },
    setErrorId(ids = []) {
      this.gradeTableRelevant.tableDataSource.forEach((item) => {
        if (ids.includes(item._courseId)) {
          this.$set(item, 'error', 1)
        }
      })
    },
    clearError() {
      this.gradeTableRelevant.tableDataSource.forEach((item) => {
        this.$set(item, 'error', undefined)
      })
    },
    validatorCourseCount(_, __, callback) {
      if (this.minChildCount < this.packForm.childCourseCount) {
        callback(new Error('课时数错误'))
      } else {
        callback()
      }
    },
    setForm(record) {
      this.packForm.name = record.name
      this.packForm.isLimitCount = !record.isLimitCount
      this.packForm.reportFrequency = undefined
      if (!this.packForm.isLimitCount) {
        this.packForm.maxCount = record.maxCount
        if (record.usedCount <= record.maxCount) {
          this.packForm.usedCount = record.usedCount
        } else {
          this.packForm.usedCount = record.maxCount
        }
      }
      this.packForm.childCourseCount = record.childCourseCount
    },
    async getForm() {
      // this.clearError()
      await this.$refs['packForm'].validate()
      await this.$refs['tableForm'].validate()
      const params = {
        ...this.packForm,
      }

      params.courseConfigs = []
      params.courseReports = {}
      this.gradeTableRelevant.tableDataSource.forEach((item) => {
        params.courseConfigs.push({
          courseResourceId: item._courseId,
          courseReportIds: item.selectReportIds,
          reportFrequency: item.reportFrequency,
        })
      })
      return params
    },
    getSelectReports(record) {
      const result = []
      if (!record.reports) {
        return result
      }
      record.reports.forEach((item) => {
        if (record.selectReportIds.includes(item.templateId + '-' + item.courseReportId)) {
          result.push({ courseReportId: item.courseReportId, reportTemplateId: item.templateId, reportTemplateTypeId: item.templateTypeId })
        }
      })
      return result
    },
    changeCustom() {
      this.customChildCount = !this.customChildCount
      this.activeHour = undefined
      this.packForm.childCourseCount = undefined
      this.$refs['packForm'].clearValidate(['childCourseCount'])
    },
    onChangeLimitPerson() {
      // this.packForm.configUserCount = 0
    },
    onChangeAllCourseCount(e) {},
    changePackCountHour(e) {
      this.customChildCount = false
      this.packForm.childCourseCount = this.packMinList.find((item) => item.value == this.activeHour)?.number
      this.$refs['packForm'].model.childCourseCount = this.packForm.childCourseCount
      this.formKey = +new Date()
    },
    removeCourse(record) {
      if (this.gradeTableRelevant.tableDataSource.length == 1) {
        return this.$message.error('课程包不能为空!')
      }
      this.$confirm({
        title: `确认提示`,
        content: '确认要移除该课程？',
        okType: 'danger',
        centered: true,
        onOk: () => {
          this.gradeTableRelevant.tableDataSource = this.gradeTableRelevant.tableDataSource.filter((item) => item.id != record.id)
        },
      })
    },
    addCourse() {
      this.selectCourse.visible = true
    },
    getPopupContainer(el) {
      return el
    },
    resetFields() {
      this.$refs['packForm'].resetFields()
    },
    changeReport() {},
    async getReportTemplateByCourseId(courseIds = []) {
      if (!courseIds.length) return
      this.gradeTableRelevant.tableLoading = true
      const { data } = await this.$http.CourseResource.CourseReportsList({ courseIds }).finally(() => {
        this.gradeTableRelevant.tableLoading = false
      })
      this.gradeTableRelevant.tableDataSource = this.gradeTableRelevant.tableDataSource.map((m) => {
        const reportList = data.filter((f) => f.courseId === m._courseId)
        return {
          ...m,
          selectReportIds: m.selectReportIds || [],
          reportList: reportList.length ? reportList : m.reportList || [],
        }
      })
      this.gradeTableRelevant.tableDataSource  = [...this.gradeTableRelevant.tableDataSource]
      console.log(this.gradeTableRelevant.tableDataSource);

    },
    selectCourseOk() {
      const courseSelectedRow = this.$refs.addCourseResourceTable.courseSelectedRowKeys.map((m) => JSON.parse(m))
      if (!courseSelectedRow.length) {
        this.$message.error('请选择课程')
        return
      }
      this.gradeTableRelevant.tableDataSource.push(
        ...courseSelectedRow.map((v) => {
          v.courseName = v.name
          v._courseId = v.id
          v._add = true
          return v
        })
      )
      this.selectCourse.visible = false
      this.getReportTemplateByCourseId(courseSelectedRow.map((v) => v.id))
    },
  },
}
</script>
<style scoped lang="less">
.form-person,
.form-hour,
.pack-title {
  display: flex;
  align-items: center;
}
.ml20 {
  margin-left: 20px;
}
.mt12 {
  margin-bottom: 12px;
}
.report ::v-deep .ant-form-item {
  margin-bottom: 0;
}
</style>
<style>
.packreport-select-error {
  /* color: #f5222d;
  font-size: 14px; */
}
</style>
